/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_settings_validation_confirm_password_required = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please confirm your password`)
};

const zh_hans1_settings_validation_confirm_password_required = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请确认您的密码`)
};

const zh_hant1_settings_validation_confirm_password_required = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`請確認新密碼`)
};

const fr_settings_validation_confirm_password_required = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veuillez confirmer votre mot de passe`)
};

const de_settings_validation_confirm_password_required = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte bestätige dein Passwort`)
};

const ja_settings_validation_confirm_password_required = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`パスワードを確認してください`)
};

const ko_settings_validation_confirm_password_required = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`새 비밀번호를 확인하세요`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "zh-Hans" | "zh-Hant" | "fr" | "de" | "ja" | "ko" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const settings_validation_confirm_password_required = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.settings_validation_confirm_password_required(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("settings_validation_confirm_password_required", locale)
	if (locale === "en") return en_settings_validation_confirm_password_required(inputs)
	if (locale === "zh-Hans") return zh_hans1_settings_validation_confirm_password_required(inputs)
	if (locale === "zh-Hant") return zh_hant1_settings_validation_confirm_password_required(inputs)
	if (locale === "fr") return fr_settings_validation_confirm_password_required(inputs)
	if (locale === "de") return de_settings_validation_confirm_password_required(inputs)
	if (locale === "ja") return ja_settings_validation_confirm_password_required(inputs)
	return ko_settings_validation_confirm_password_required(inputs)
};